import React from 'react';

/** The one-page "single's CV" (US Letter, 816 x 1056 CSS px). Only the slides she chose appear. */
const CvView = ({ theme, included, vals, photos }) => {
  const has = (id) => included.includes(id);
  const v = (id, k) => vals[`${id}.${k}`] || '';
  const name = (has('about') && v('about', 'name')) || v('cover', 'title') || 'The Wifey Application';
  const facts = has('about') ? [v('about', 'age') && `Age ${v('about', 'age')}`, v('about', 'place'), v('about', 'work')].filter(Boolean).join('  ·  ') : '';
  const photo = (has('cover') && photos.cover) || (has('about') && photos.about) || null;
  return (
    <div className={`cv t-${theme}`}>
      <div className="cv-top">
        <div>
          <div className="cv-eye">The Wifey Application</div>
          <h2>{name}</h2>
          {facts && <div className="cv-facts">{facts}</div>}
          {has('cover') && v('cover', 'tagline') && <div className="cv-tag">{v('cover', 'tagline')}</div>}
        </div>
        {photo && <div className="cv-ph" style={{ backgroundImage: `url("${photo}")` }} />}
      </div>
      <div className="cv-grid">
        {has('about') && v('about', 'known') && (
          <div className="cv-sec"><h3>Best known for</h3><p>{v('about', 'known')}</p></div>
        )}
        {has('seeking') && (
          <div className="cv-sec">
            <h3>Who I am seeking</h3>
            <dl>
              {v('seeking', 'ageR') && <div><dt>Age</dt><dd>{v('seeking', 'ageR')}</dd></div>}
              {v('seeking', 'love') && <div><dt>Must love</dt><dd>{v('seeking', 'love')}</dd></div>}
              {v('seeking', 'traits') && <div><dt>Preferences</dt><dd>{v('seeking', 'traits')}</dd></div>}
            </dl>
          </div>
        )}
        {has('deen') && <div className="cv-sec cv-wide"><h3>My deen</h3><p>{v('deen', 'deen')}</p></div>}
        {has('why') && <div className="cv-sec cv-wide"><h3>Why I am doing this</h3><p>{v('why', 'why')}</p></div>}
      </div>
      {has('apply') && (
        <div className="cv-apply">
          <b>How to apply</b>
          Please fill out the application at the {v('apply', 'link')}. Applications close {v('apply', 'closes')}.
          {vals['apply.wali'] && ' DMs will not receive a response. There is a formal process, and my wali reviews every application.'}
        </div>
      )}
      <div className="cv-foot">JazakAllahu khayran, and may Allah grant every one of us what is best for our dunya and akhirah</div>
    </div>
  );
};

export default CvView;
